import {
    ThemeBorderVariable,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Heading } from "@caspeco/casper-ui-library.components.heading";
import { Skeleton } from "@caspeco/casper-ui-library.components.skeleton";
import { Stack } from "@caspeco/casper-ui-library.components.stack";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { useReservation } from "api/api-hooks/use-create-reservation";
import { t } from "i18next";

export function WaitListStartTimes() {
    const { data: reservation } = useReservation();
    const border = `${ThemeBorderVariable.XSmall} ${ThemeColorVariable.OnSurfaceBorder}`;
    if (!reservation?.articles || !reservation?.nonTableArticles) {
        return (
            <Stack>
                <Skeleton height="22px" w="40%" />
                <Skeleton height="58px" w="full" />
            </Stack>
        );
    }
    const articleGroupName = reservation.articles.at(0)?.articleGroupName;
    const isWaitList = reservation.isWaitList();
    return (
        <Stack>
            <Heading as="h4" fontWeight={"medium"} fontSize={ThemeFontSizeVariable.Large}>
                {isWaitList
                    ? t("waitList.timesWithWaitListForX", {
                          articleGroupName,
                      })
                    : t("myBooking")}
            </Heading>
            <Stack
                border={border}
                borderRadius={ThemeRadiusVariable.Small}
                p={ThemeSpaceVariable.Medium}
            >
                <Stack spacing={ThemeSpaceVariable.XSmall} direction="row" flexWrap="wrap">
                    {reservation?.articles.map((article, index) => (
                        <Text key={index}>
                            {article.start.format("HH:mm")}
                            {index !== reservation.articles.length - 1 && ","}
                        </Text>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
}
